// extracted by mini-css-extract-plugin
export default {"formContainer":"style_formContainer__T+uMr"};